import React from 'react';

import Image from '~/src/components/image/Image';

import css from './ScoreboardTennis.module.scss';

class ScoreboardTennis extends React.Component {
    render() {
        return (
            <div className={css.scoreboardTennis}>
                <span className={css.playerName}>{this.props.teams[0].name}</span>
                {this.props.teams.map((team, index) => {
                    return (
                        <div className={css.scoreboardRow} key={index}>
                            <div className={css.scoreboardProfile}>
                                <div className={css.playerImageContainer}>
                                    <Image {...team.image} label={team.name} />
                                </div>
                            </div>
                            <div className={css.scoreboardPoints}>
                                <span className={css.scoreboardPointsContent}>{this.props.score.points[index]}</span>
                            </div>
                            <div className={css.scoreboardSets}>
                                {this.props.score.sets.map((set, i) => {
                                    return (
                                        <div className={css.scoreboardSet} key={i}>
                                            <span className={css.scoreboardSetContent}>{set[index]}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
                <span className={css.playerName}>{this.props.teams[1].name}</span>
            </div>
        );
    }
}

export default ScoreboardTennis;
